import User from "models/user";
import Role from "models/role";

export const isAdmin = (user: User | null): boolean => Boolean(user?.is_admin);

export const getRole = (user: User | null): Role =>
  isAdmin(user) ? "admin" : "user";
